/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadCommentCount
 */
export interface LeadCommentCount {
    /**
     * 
     * @type {string}
     * @memberof LeadCommentCount
     */
    lead_id: string;
    /**
     * 
     * @type {number}
     * @memberof LeadCommentCount
     */
    comment_count: number;
}

/**
 * Check if a given object implements the LeadCommentCount interface.
 */
export function instanceOfLeadCommentCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "comment_count" in value;

    return isInstance;
}

export function LeadCommentCountFromJSON(json: any): LeadCommentCount {
    return LeadCommentCountFromJSONTyped(json, false);
}

export function LeadCommentCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCommentCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'comment_count': json['comment_count'],
    };
}

export function LeadCommentCountToJSON(value?: LeadCommentCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'comment_count': value.comment_count,
    };
}

